var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.499,
    height: 12.408,
    viewBox: "0 0 19.499 12.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M13.295,107.318a2.659,2.659,0,1,0-2.659-2.659A2.611,2.611,0,0,0,13.295,107.318Zm-7.09,0A2.659,2.659,0,1,0,6.2,102a2.659,2.659,0,1,0,0,5.318Zm0,1.773c-2.039,0-6.2,1.064-6.2,3.1v2.216H12.408v-2.216C12.408,110.154,8.243,109.09,6.2,109.09Zm7.09,0a3.325,3.325,0,0,0-.886.089,3.656,3.656,0,0,1,1.773,3.013v2.216H19.5v-2.216C19.5,110.154,15.333,109.09,13.295,109.09Z",
    transform: "translate(0 -102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.d17a71ab.svg";
export { ForwardRef as ReactComponent };